"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styles_1 = require("@mui/styles");
const i18n_util_1 = require("../@common/util/i18n-util");
const style_util_1 = require("../@common/util/style-util");
const config_1 = __importDefault(require("../@internal/config"));
const material_1 = require("@mui/material");
const { services: { support: { url: SUPPORT_URL } } } = config_1.default;
const translateErrors = key => i18n_util_1.translate('lwt-lib-a11ySettings', key);
const OOPS_GREEN = '#399C22';
const Page500 = ({ imgSrc = i18n_util_1.getTranslatedImage('500-oops-kid.png'), goBacklabel = translateErrors('goBack'), color = OOPS_GREEN }) => {
    const theme = material_1.useTheme();
    const classes = useStyles(theme)({ color });
    const handleGoBack = () => {
        window.history.go(-2);
    };
    const renderButtons = () => {
        return (react_1.default.createElement("div", { className: classes.buttons },
            react_1.default.createElement("button", { className: classes.anchor, onClick: handleGoBack }, goBacklabel),
            react_1.default.createElement("button", { className: classes.anchor },
                react_1.default.createElement("a", { href: SUPPORT_URL }, translateErrors('contact')))));
    };
    return (react_1.default.createElement("div", { className: classes.outerContainer },
        react_1.default.createElement("div", { className: classes.imgContainer },
            react_1.default.createElement("img", { className: classes.img, src: imgSrc, alt: translateErrors('500ImgAlt') })),
        react_1.default.createElement("section", { className: classes.textSection },
            react_1.default.createElement("span", { className: classes.span }, translateErrors('500Title')),
            react_1.default.createElement("h1", { className: classes.heading1 }, translateErrors('wrong')),
            react_1.default.createElement("h2", { className: classes.heading2 }, translateErrors('internalError')),
            renderButtons(),
            react_1.default.createElement("p", { style: { marginTop: 30 } },
                "Version: ",
                process.env.REACT_APP_APP_VERSION))));
};
const useStyles = theme => styles_1.makeStyles({
    anchor: {
        backgroundColor: ({ color }) => color,
        border: 'none',
        borderRadius: '0.2rem',
        color: theme.palette.primary.contrastText,
        cursor: 'pointer',
        fontSize: '0.8rem',
        fontWeight: 500,
        margin: '0 0.5rem 0 0',
        padding: '0.35rem 1.2rem',
        '& a': {
            color: theme.palette.primary.contrastText,
            textDecoration: 'none'
        },
        ':active': {
            backgroundColor: ({ color }) => color,
            color: theme.palette.primary.contrastText,
            textDecoration: 'none'
        },
        ':focus': {
            outline: 'none'
        },
        ':hover': {
            color: theme.palette.primary.contrastText,
            textDecoration: 'none'
        },
        ':link': {
            backgroundColor: ({ color }) => color,
            color: theme.palette.primary.contrastText,
            textDecoration: 'none'
        },
        ':visited': {
            backgroundColor: ({ color }) => color,
            color: theme.palette.primary.contrastText,
            textDecoration: 'none'
        }
    },
    buttons: {
        margin: '1.2rem 0'
    },
    heading1: {
        fontSize: '3.5rem',
        fontWeight: 500,
        margin: '0.5rem 0'
    },
    heading2: {
        fontSize: '1.5rem',
        fontWeight: 300,
        margin: 0
    },
    img: {
        height: style_util_1.remCalc(550)
    },
    imgContainer: {
        height: '70%',
        marginRight: '5%'
    },
    outerContainer: {
        alignItems: 'center',
        backgroundColor: theme.palette.primary.contrastText,
        display: 'flex',
        flexDirection: 'row',
        fontFamily: 'GSS Futura',
        fontSize: '1.2rem',
        justifyContent: 'center',
        height: '100%',
        width: '100%'
    },
    textSection: {
        position: 'relative',
        top: '-6%'
    },
    span: {
        fontSize: '1.3rem',
        fontWeight: 300
    }
});
exports.default = Page500;
